import { module } from 'angular';

import { default as unitaryTargetSelectionName, UnitaryTargetSelection } from './unitary-target-selection.component';

export default module('contact.agent.unitary-target-selection', []).component(unitaryTargetSelectionName, new UnitaryTargetSelection())
  .name;
